import { useContext } from 'react';
import useSmartState from '../../../../common/hooks/useSmartState';
import { SmartContext } from '../../../../library/Core/SmartContext';

const StatsBar = () => {
    const { state } = useContext(SmartContext);
    const { setStateValue } = useSmartState();

    const searchCriteria = state.data?.searchCriteria || {};
    const stats = state.data?.stats || { total: 0, new: 0, responded: 0, converted: 0 };

    const statCards = [
        {
            id: 'total',
            label: 'Total',
            value: stats.total,
            isActive: !searchCriteria.status && !searchCriteria.outcome,
            nextCriteria: { ...searchCriteria, status: '', outcome: '', page: 1 },
        },
        {
            id: 'new',
            label: 'New',
            value: stats.new,
            isActive: searchCriteria.status === 'NEW',
            nextCriteria: { ...searchCriteria, status: 'NEW', outcome: '', page: 1 },
        },
        {
            id: 'responded',
            label: 'Responded',
            value: stats.responded,
            isActive: searchCriteria.status === 'RESPONDED',
            nextCriteria: { ...searchCriteria, status: 'RESPONDED', outcome: '', page: 1 },
        },
        {
            id: 'converted',
            label: 'Converted',
            value: stats.converted,
            isActive: searchCriteria.outcome === 'CONVERTED',
            nextCriteria: { ...searchCriteria, status: '', outcome: 'CONVERTED', page: 1 },
        },
    ];

    return (
        <div className="row g-3 mb-4">
            {statCards.map((card) => (
                <div className="col-lg-3 col-sm-6" key={card.id}>
                    <button
                        type="button"
                        className={`w-100 border-0 text-start p-4 border-radius-6 ${card.isActive ? 'bg-darker-blue text-white' : 'bg-gray-F2F4F7 text-dark'}`}
                        onClick={() => setStateValue('searchCriteria', card.nextCriteria as any)}>
                        <div className="font-14 font-500 mb-2 opacity-75">{card.label}</div>
                        <div className="font-28 font-600">{card.value}</div>
                    </button>
                </div>
            ))}
        </div>
    );
};

export default StatsBar;